import { combineReducers, Dispatch, Action, AnyAction } from "redux";
import { connectRouter } from 'connected-react-router';
import { all, fork } from "redux-saga/effects";
import { History } from "history";

// 登陆验证模块
import { AuthorizationState } from "./authorization/types";
import { getUserReducer } from "./authorization/reducer";
import authorizationSaga from "./authorization/sagas";

// 发放列表
import { PayState } from "./pay/types";
import { payReducer } from "./pay/reducer";
import paySaga from "./pay/sagas";

// 最上一级的state
export interface ApplicationState {
  router: any;
  authorizationState: AuthorizationState;
  payState: PayState;
}

// 添加属性给react组件，此属性默认传递给connect()方法
export interface ConnectedReduxProps<A extends Action = AnyAction> {
  dispatch: Dispatch<A>
}

// 当action被调度, Redux根据名称去匹配reducer，然后更新相应的state
export const rootReducer = (history: History<any>) => combineReducers<ApplicationState>({
  router: connectRouter(history),
  authorizationState: getUserReducer,
  payState: payReducer
})

// 合并saga
export function* rootSaga() {
  yield all([
    fork(authorizationSaga),
    fork(paySaga),
  ])
}



// WEBPACK FOOTER //
// ./src/store/index.ts